// extracted by mini-css-extract-plugin
export default {"modal":"AddEntityModal_modal__2r-dp","submitButton":"AddEntityModal_submitButton__jnXmS","customFooter":"AddEntityModal_customFooter__v93Vj"};